import React, { useEffect, useState } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import axios from 'axios';
import './AuthPages.css';
import { API_BASE } from '../services/authService';
import { useLanguage } from '../context/languageContext';

export default function OAuthCallback({ onLoginSuccess }) {
  const [error, setError] = useState(null);
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();
  const { t } = useLanguage();

  useEffect(() => {
    const code = searchParams.get('code');
    const state = searchParams.get('state');
    const savedState = sessionStorage.getItem('github_oauth_state');

    if (!code) {
      setError(t('oauth.missingCode'));
      return;
    }

    if (savedState && state && savedState !== state) {
      setError(t('oauth.stateFail'));
      return;
    }

    const exchangeCode = async () => {
      try {
        const response = await axios.post(`${API_BASE}/api/auth/github/callback/`, {
          code,
          state,
        });

        const payload = response?.data ?? {};
        const access = payload.access || payload.accessToken || payload.token;
        const refresh = payload.refresh || payload.refreshToken;
        const user = payload.user || payload.profile || {};

        if (access) {
          await onLoginSuccess({
            username: user.username || payload.username || 'github-user',
            accessToken: access,
            refreshToken: refresh,
            ...user,
            is_staff: user.is_staff ?? payload.is_staff ?? false,
          });
          sessionStorage.removeItem('github_oauth_state');
          navigate('/', { replace: true });
        } else {
          setError(t('oauth.noCredential'));
        }
      } catch (err) {
        console.error('GitHub OAuth callback error:', err);
        const serverMessage = err?.response?.data?.detail || err?.response?.data?.message || err?.message;
        setError(serverMessage ? `${t('oauth.failed')}${serverMessage}` : t('oauth.failedGeneric'));
      }
    };

    exchangeCode();
    // 该副作用仅需执行一次（交换授权码），不随语言切换重跑
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [searchParams, onLoginSuccess, navigate]);

  return (
    <div className="oauth-callback-page">
      {error ? <div className="error-message">{error}</div> : <div className="oauth-processing">{t('oauth.processing')}</div>}
    </div>
  );
}
